module.exports = __webpack_public_path__ + "static/media/super.05536077.webp";